import ADPModuleService from "../../../../services/admin/ADPModuleService";
import ADPRefcodeService from "../../../../services/admin/ADPRefcodeService";
import ADPRefgroupService from "../../../../services/admin/ADPRefgroupService";

class referenceService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async findAllReferenceGroup(): Promise<any> {
        return await ADPRefgroupService.findAll();
    }

    async findAllReferenceCode(moduleId: any, referenceGroup: any): Promise<any> {
        return await ADPRefcodeService.getItemByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async getModuleDropdown(): Promise<any> {
        return await ADPModuleService.getDropdown();
    }

    async create(item: any): Promise<any> {
        return await ADPRefgroupService.create(item);
    }

    async update(item: any): Promise<any> {
        return await ADPRefgroupService.update(item.moduleId, item.referenceGroup, item);
    }

    async addRefCd(item: any): Promise<any> {
        return await ADPRefcodeService.create(item);
    }
}

export default new referenceService();
